import team1 from "../../assets/team1.jpg";
import team2 from "../../assets/team2.jpg";
import team3 from "../../assets/team3.jpg";

const teamData = [
  {
    id: 1,
    img: team2,
    alt: "Photo of the technology expert - Piotr Smoła.",
    name: "Piotr Smoła",
    role: "Backend Developer",
    facebook: "https://www.facebook.com/profile.php?id=100008145638313",
    twitter: "https://x.com/",
    instagram: "https://instagram.com/",
  },
  {
    id: 2,
    img: team1,
    alt: "Photo of the technology expert - Dawid Olko.",
    name: "Dawid Olko",
    role: "Data Scientist",
    facebook: "https://www.facebook.com/olkodawid/",
    twitter: "https://x.com/nullfresh",
    instagram: "https://instagram.com/dawid_olko",
  },
  {
    id: 3,
    img: team3,
    alt: "Photo of the technology expert - Anna Kowalska.",
    name: "Anna Kowalska",
    role: "UI/UX Designer",
    facebook: "https://www.facebook.com/",
    twitter: "https://x.com/",
    instagram: "https://instagram.com/",
  },
];

export default teamData;
